class StickyColor {
    constructor(divSticky, divContainers) {
        if (divSticky === undefined) divSticky = "sticky";
        if (divContainers === undefined) divContainers = "content";
        this.sticky = document.getElementById(divSticky);
        this.contentDivs = document.getElementsByClassName(divContainers);
        this.addEvents();
    }

    addEvents() {
        window.addEventListener('scroll',  (e) => {
               Array.prototype.forEach.call(this.contentDivs, (_el, index) => {
                   var _thisOffset = _el.offsetTop;
                   var _actPosition = _thisOffset - window.scrollY;
                   if (_actPosition < this.sticky.offsetTop && _actPosition + _el.getBoundingClientRect().height > 0) {
                      this.sticky.classList.remove("light","dark");
                      this.sticky.classList.add(_el.classList.contains("light") ? "light" : "dark");
                   }
               })
        });
    }

}

export default StickyColor;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/stickyColor.js